import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onUploadError, onUploadFinished, onUploadProgress, onUploadsSelected, onUploadStarted, onValidateFile} from '../actions/ImageActions';
import FileUpload from '../components/FileUpload';

@connect((state) => ({
    currentUser: state.auth.currentUser,
}), {
    onUploadError,
    onUploadFinished,
    onUploadProgress,
    onUploadsSelected,
    onUploadStarted,
})
export default class FileUploadContainer extends Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onUploadsSelected: PropTypes.func,
        onUploadStarted: PropTypes.func,
        onUploadError: PropTypes.func,
        onUploadProgress: PropTypes.func,
        onUploadFinished: PropTypes.func,
        children: PropTypes.node,
        uploadContext: PropTypes.string,
        multiple: PropTypes.bool,
        disabled: PropTypes.bool,
        fileUploadRef: PropTypes.func,
    };

    render() {
        const {children, disabled} = this.props;
        if (disabled) {
            return children;
        }
        const {currentUser, uploadContext, multiple, fileUploadRef} = this.props;
        const {usageLimit, currentUsage} = currentUser;
        const hasFileUpload = usageLimit < 0 || currentUsage < usageLimit;

        if (!hasFileUpload) {
            return children;
        }
        return (
            <FileUpload
                uploadContext={uploadContext}
                multiple={multiple}
                ref={fileUploadRef}
                disableClick={true}
                accept={'image/gif,image/jpeg,image/png'}
                onValidateFile={onValidateFile}
                onUploadsSelected={this.props.onUploadsSelected}
                onUploadFinished={this.props.onUploadFinished}
                onUploadStarted={this.props.onUploadStarted}
                onUploadProgress={this.props.onUploadProgress}
                onUploadError={this.props.onUploadError}
                style={{height: '100%'}}>
                {children}
            </FileUpload>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/FileUploadContainer.js